import { Core } from "@faire/design-tokens";
import { Tooltip } from "@faire/web/slate-deprecated/Tooltip";
import { PortalTooltip } from "@faire/web/slate-deprecated/Tooltip/PortalTooltip";
import { ITooltipProps } from "@faire/web/slate-deprecated/Tooltip/Tooltip";
import { Row } from "@faire/web/slate/Layout";
import { Toast } from "@faire/web/slate/Toast/Toast";
import { Typography } from "@faire/web/slate/Typography";
import { useViewport } from "@faire/web/ui/hooks/useViewport";
import * as React from "react";

interface ITooltipOrToastProps extends ITooltipProps {
  toastTimeout?: "short" | "medium" | "long";
  usePortal?: boolean;
  portalTooltipYOffset?: number;
  tooltipZIndex?: number;
  "data-test-id"?: string;
}

export const TooltipOrToast: React.FC<ITooltipOrToastProps> = (props) => {
  const viewport = useViewport();

  const showToast = () => {
    if (props.hidden) {
      return;
    }

    let renderedContents = null;
    if (props.contents !== undefined) {
      if (Array.isArray(props.contents)) {
        renderedContents = props.contents.map((c) => c.body);
      } else {
        renderedContents = props.contents.bodies;
      }
    }

    Toast.dismiss();
    Toast.create(
      <Row>
        <Typography color={Core.text.inverse}>
          {renderedContents} {props.action}
        </Typography>
      </Row>,
      { timeout: props.toastTimeout ?? "long" }
    );
  };

  if (viewport.isMobile) {
    if (props.hidden) {
      return props.targetNode;
    }
    return (
      <div data-test-id="quick-add-show-toast-mobile" onClick={showToast}>
        <div style={{ pointerEvents: "none" }}>{props.targetNode}</div>
      </div>
    );
  }

  const { contents, hidden, action, tooltipZIndex } = props;
  return props.usePortal ? (
    <PortalTooltip
      placement="top"
      tooltipZIndex={tooltipZIndex}
      tooltip={
        <Tooltip
          contents={contents}
          targetNode={<></>}
          isOpen={!hidden}
          action={action}
        />
      }
      data-test-id={props["data-test-id"]}
      tooltipMainAxisOffset={props.portalTooltipYOffset}
    >
      {props.targetNode}
    </PortalTooltip>
  ) : (
    <Tooltip {...props} />
  );
};
